import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Portfolio from './Portfolio';
import PortfolioMahaney from './PortfolioMahaney';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import ClientPortal from './pages/ClientPortal';
import BriefPage from './pages/BriefPage';

const isAdminSubdomain = typeof window !== 'undefined' &&
  window.location.hostname.startsWith('admin.');

function RequireAuth({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/portal" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#f2f2ee' }} />
  );

  return (
    <Routes>
      <Route path="/login" element={
        user ? <Navigate to={user.role === 'admin' ? '/admin' : '/portal'} replace /> : <Login />
      } />

      <Route path="/admin" element={
        <RequireAuth adminOnly>
          <AdminDashboard />
        </RequireAuth>
      } />
      <Route path="/admin/briefs/:id" element={
        <RequireAuth adminOnly>
          <BriefPage />
        </RequireAuth>
      } />

      <Route path="/portal" element={
        <RequireAuth>
          <ClientPortal />
        </RequireAuth>
      } />
      <Route path="/portal/briefs/:id" element={
        <RequireAuth>
          <BriefPage />
        </RequireAuth>
      } />

      <Route path="/v2/*" element={<PortfolioMahaney />} />
      {/* On admin.piercebtownsend.com, any unmatched path falls into admin */}
      <Route path="/*" element={isAdminSubdomain ? <Navigate to="/admin" replace /> : <Portfolio />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
